export const MutationTypes = {
	COUNTERS: 'COUNTERS',
	GENERAL_ERRORS: 'GENERAL_ERRORS',
	VERIFICATION_IN_PROGRESS: 'VERIFICATION_IN_PROGRESS',
	FEATURES: 'FEATURES'
};
